import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import VuexPersistence from 'vuex-persist';

import media from './module/media';
import mobildConfig from './module/mobildConfig';

const store = new Vuex.Store({
	state: {
		count:1,
		msg:'这里是state的初始化数据。',
		resourcePermissions: []
	},
	getters: {    // 监听数据变化的
		getPermissions(state){
			if (state.resourcePermissions.length > 0) {
				return state.resourcePermissions
			}
			return sessionStorage.getItem("resourcePermissions");
		}
	},
	mutations: {
		SET_PERMISSIONS(state, permissions) {
			sessionStorage.setItem("resourcePermissions", permissions)
			state.resourcePermissions = permissions;
		}
	},
    plugins: [
        new VuexPersistence({
            reducer: (state) => ({
                mobildConfig: state.mobildConfig,
                media: state.media,
            }),
            storage: window.localStorage,
        }).plugin,
    ],
    modules: {
        mobildConfig,
        media
    },
})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js